import { useCallback, useEffect } from "react"

import { useAuth } from "shared/lib/useAuth"
import { useWindowFocus } from "shared/lib/useWindowFocus"

export function usePrefetch<T>(fetchFn: () => Promise<T>) {
  const { isAuthenticated } = useAuth()

  const handleFetch = useCallback(() => {
    if (isAuthenticated) {
      fetchFn()
    }
  }, [isAuthenticated, fetchFn])

  useEffect(() => {
    handleFetch()
  }, [handleFetch])

  useWindowFocus(handleFetch)
}
